export default __webpack_public_path__ + "static/media/109.be9564dd.jpg";